import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=f7bd5762&scoped=true&"
import script from "./TextView.vue?vue&type=script&lang=js&"
export * from "./TextView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bd5762",
  null
  
)

export default component.exports